function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "37.072%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F0F0F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F0F0F5"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  fillRule: "nonzero",
  stroke: "#BEBFCB",
  d: "M6.72 23.497a2.175 2.175 0 0 1 .399-1.525l2.927-4.048a2.5 2.5 0 0 1 4.036-.021l2.386 3.228V20.6a3.5 3.5 0 0 1 3.5-3.5h.4a3.5 3.5 0 0 1 3.5 3.5v2.896l1.358.001.07.003.119-.003h.395l.233-.007c2.742-.13 5.01-2.168 5.399-4.86.4-2.77-1.304-5.417-4.015-6.228l-.357-.107V11.36l-.004-.22c-.112-3.089-2.681-5.546-5.82-5.546-.555 0-1.107.079-1.64.235l-.403.119-.186-.378c-2.205-4.476-7.663-6.338-12.19-4.155C2.305 3.596.426 8.991 2.629 13.464l.178.361-.314.251a5.259 5.259 0 0 0-1.696 5.86l.083.218a5.358 5.358 0 0 0 4.943 3.343h.898z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D01E29",
  d: "M11.972 19c.096-.003.19.04.257.122l2.73 3.945c.117.165-.03.374-.264.374H13.5V31a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-7.56H9.323c-.235 0-.381-.208-.3-.373l2.7-3.945a.313.313 0 0 1 .25-.122zm8.528 0a1 1 0 0 1 1 1v7.56h1.177c.235 0 .381.208.3.373l-2.7 3.945a.313.313 0 0 1-.25.122.319.319 0 0 1-.256-.122l-2.73-3.945c-.117-.165.03-.374.264-.374H18.5V20a1 1 0 0 1 1-1z"
}));

var SvgTransmissaoDeDados = function SvgTransmissaoDeDados(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransmissaoDeDados, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transmissao-de-dados.9a822c54.svg";
export { ForwardRef as ReactComponent };